<template>
    <transition name="fade" mode="out-in">
        <div class="row">
            <div class="col-md-12 mb-2">
                <h4>KEAGENAN LPG</h4>
            </div>

            <div class="col-md-12 mb-4">
                <el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px', paddingTop: '16px', paddingBottom: '16px' }">
                    <div class="col-md-12 mb-4">
                        <h6 class="title-section" v-if="false">Keagenan LPG</h6>

                        <div>
                            <el-form label-position="top" label-width="100px">
                                <div class="row">   
                                    <div class="col-md-4">                 
                                        <el-form-item label="Status">
                                            <el-radio-group v-model="status" size="small" name="status">
                                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>  
                                    <div class="col-md-2">    
                                        <el-form-item label=" ">
                                            <el-button type="success" :loading="loading.table" size="medium" @click="applyFilter" style="width:190px;height:35px;margin-left:12px;">Apply Filter</el-button>
                                        </el-form-item>  
                                    </div>
                                </div>
                            
                            </el-form>
                        </div>

                        <vue-bootstrap4-table                
                            :columns="this.table.columns" 
                            :rows="this.keagenan.list" 
                            :config="this.table.config" 
                            :classes="this.table.classes"
                            style="margin-top:0px;"
                            v-loading.body="loading.table"
                            />
                    
                    </div>
                </el-card>
            </div>
        </div>
    </transition>
</template>

<script>

import LPG from '@/components/page/LPG.js'
import { AxiosWithJar,Config } from '@/utility.js'

// import Vue from 'vue'
// import { VuejsDatatableFactory } from 'vuejs-datatable';
// Vue.use( VuejsDatatableFactory );

//import {AxiosWithJar,Penanggalan, Config} from '@/utility.js'
// import datatable from '../../components/datatable.vue'

//import Vue from 'vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
//import {VuejsDatatableFactory} from 'vuejs-datatable'
//Vue.use(VuejsDatatableFactory)

export default
{
	extends: LPG,
	components: { VueBootstrap4Table },

    /*
    data:()=>({
        //fields: ["BranchId", "BranchName", "SAP_PlantNo", "ProvinceName", "Address"],
        
       

    }),
    */

    data() {
		return {
            table: {
                columns:[
                    {label: 'Branch Id', name: 'BranchId',sort:true,filter:{type:"simple"},row_text_alignment: "text-left", column_text_alignment: "text-left",},
                    {label: 'Branch Name', name: 'BranchName',sort:true,filter:{type:"simple"},row_text_alignment: "text-left", column_text_alignment: "text-left",},
                    {label: 'Plant', name: 'SAP_PlantNo',sort:true,filter:{type:"simple"},row_text_alignment: "text-left", column_text_alignment: "text-left",},
                    {label: 'Province', name: 'ProvinceName',sort:true,filter:{type:"simple"},row_text_alignment: "text-left", column_text_alignment: "text-left",},
                    {label: 'Address', name: 'Address',sort:true,filter:{type:"simple"},row_text_alignment: "text-left", column_text_alignment: "text-left",},
                ],                
                config: {
                    pagination: true,
                    pagination_info: true,
                    num_of_visibile_pagination_buttons: 5,
                    per_page: 50,
                    checkbox_rows: false,
                    highlight_row_hover: true,
                    rows_selectable: true,
                    multi_column_sort: true,
                    // highlight_row_hover_color:"grey",
                    //card_title: "",
                    card_mode: false,
                    selected_rows_info:true,
                    per_page_options: [50, 100, 200, 250],
                },
                classes: {
                    table: "table-striped"
                },            
            },

            options: {
                status:[
                    { value: "", name: "ALL" },
                    { value: "1", name: "Active" },
                    { value: "0", name: "Inactive" },
                ],
            },
            loading: {
                table: false,
                chart: false,
                isSuccess: false, //is request success or error
            },
            status: this.$route.query.status ? this.$route.query.status : '',
        }
    },

    mounted()
    {
        this.$emit('childrenRoute');
		this.loadKeagenanList();
    },
    
    methods:{
        async loadKeagenanList() {
            let url = Config().apiURL + "/lpg/keagenanlist?"
            url +='&status='+this.status

            this.loading.table = true
			//url = Config().apiURL + "/lpg/keagenanlist"
			await AxiosWithJar().get(url)
            .then(result => {
                this.loading.isSuccess = true
				if (result.data.list.length) {
					this.keagenan.list = result.data.list;
				}
			})
            .catch(error => {
                //console.log(error)
                this.loading.isSuccess = false
                this.reportdata = []
                let errMsg = error
                this.$alert(errMsg, 'Error', {
                    confirmButtonText: 'Close',
                    callback: action => {
                        this.$message({
                        type: 'danger',
                        message: `Please try again.`
                        });
                    }
                });
            })
            .finally(() => {
                this.loading.table = false;
            })
		},
        applyFilter() {
            this.loadKeagenanList()
        },
    }
}
</script>
<style>
/*
    table.table{ font-size: 12px;}
    table.table tr.vbt-table-tools{display: none;}
    table.table th{ padding: 10px 10px !important;}
    table.table .form-group{ margin-bottom: 0px;}
		*/

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>